export default theme => ({
    helperText: {
        fontSize: theme.typography.fontSize,
        margin: `-${theme.spacing(1)} 0 ${theme.spacing(1.5)} ${theme.spacing(3.75)}`,
    },
});
